module.exports = __webpack_public_path__ + "img/cheese.64fa12bc.svg";